import { render } from "./KeyPad.vue?vue&type=template&id=980b4852"
import script from "./KeyPad.vue?vue&type=script&lang=js"
export * from "./KeyPad.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__